import { useCallback, useState } from 'react';

export function useStateSetAsArray<T>(initialItems: T[]): [T[], (item: T) => void, (item: T) => void] {
  const [items, setItems] = useState(initialItems);

  const addItem = useCallback(
    (item: T) => {
      setItems(Array.from(new Set([...items, item])));
    },
    [items, setItems]
  );

  const removeItem = useCallback(
    (item: T) => {
      setItems(items.filter(i => i !== item));
    },
    [items, setItems]
  );

  return [items, addItem, removeItem];
}
